(function () {
    'use strict';

    // @ngInject
    function BadgeCodeModalControllerCtor($injector, $scope, $modalInstance, AnalyticsService, UsersManager, $timeout, DeviceService, badgeCode, OnboardingService, Enums,badgeUser) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'BadgeCodeModalController';

        this.$modalInstance = $modalInstance;
        this.DeviceService = DeviceService;
        this.OnboardingService = OnboardingService;
        this.Enums = Enums;
        this.badgeCode = badgeCode;

        this.user = badgeUser;
        this.currUser = UsersManager.getCurrUser();
        AnalyticsService.trackPageView(this, 'get badge code');

        this.loadingBadgeCode = false;
        this.copyBadgeCodeMsg = false;
        
        if ( this.DeviceService.isSafari() ) {
            this.hideForSafari = true;
        };
    }

    Controllers.BadgeCodeModalController = Class(Controllers.BaseController, {
        constructor: BadgeCodeModalControllerCtor,

        dismiss: function dismiss() {
            this.$modalInstance.dismiss();
        },

        close: function close() {
            this.$modalInstance.close();
        },

        openIntakeForm: function openIntakeForm() {
            this.OnboardingService.openInProductIntakeForm(this.Enums.IntakeFormSource.tools);
            this.close();
        }

    });
}());
